import { Card, CardContent } from '@/components/ui/card'
import { CodeBlock } from '../CodeBlock'
import { useTranslation } from '@/hooks/useTranslation'

export const DjangoSection = () => {
	const { t } = useTranslation()
	
	return (
		<section id="django" className="mb-16">
			<h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-6">
				{t('docs.django.title')}
			</h2>
			<Card className="shadow-sm dark:bg-gray-800/50">
				<CardContent className="pt-6">
					<p className="mb-4 text-gray-700 dark:text-gray-300">
						{t('docs.django.instruction.prefix')}{' '}
						<code className="bg-gray-200 dark:bg-gray-700 px-1 py-0.5 rounded text-xs">
							templates/base.html
						</code>
						{t('docs.django.instruction.suffix')}
					</p>
					<CodeBlock
						language="html"
						copyLabel={t('docs.django.copyLabel')}
						copyMessage={t('docs.django.copyMessage')}
						code={`<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>{% block title %}My Django App{% endblock %}</title>
</head>
<body>
    {% block content %}
    {% endblock %}
    
    <!-- Feedbask Widget -->
    <script
        defer
        src="https://cdn.feedbask.com/widget.js"
        data-client-key="{{ FEEDBASK_WIDGET_ID }}"
        data-language="en"
        id="feedbask-widget-script"
    ></script>
</body>
</html>`}
					/>
					<div className="mt-4 p-4 bg-slate-50 dark:bg-slate-900/50 rounded-md">
						<p className="text-sm text-slate-700 dark:text-slate-300 mb-2">
							<strong>{t('docs.django.settingsConfig.title')}</strong>
						</p>
						<p className="text-sm text-slate-600 dark:text-slate-400 mb-2">
							{t('docs.django.settingsConfig.instruction.prefix')}{' '}
							<code className="bg-gray-200 dark:bg-gray-700 px-1 py-0.5 rounded text-xs">
								settings.py
							</code>
							{t('docs.django.settingsConfig.instruction.suffix')}
						</p>
						<code className="block p-2 bg-gray-100 dark:bg-gray-800 rounded text-xs font-mono">
							FEEDBASK_WIDGET_ID = 'your_actual_widget_id'
						</code>
						<p className="text-sm text-slate-600 dark:text-slate-400 mt-2">
							{t('docs.django.settingsConfig.contextProcessor.prefix')}{' '}
							<code className="bg-gray-200 dark:bg-gray-700 px-1 py-0.5 rounded text-xs">
								'FEEDBASK_WIDGET_ID': FEEDBASK_WIDGET_ID
							</code>{' '}
							{t('docs.django.settingsConfig.contextProcessor.suffix')}
						</p>
					</div>
				</CardContent>
			</Card>
		</section>
	)
}